import React from 'react';
import ImgAgam from '../Img/editorial-board-agam.png';
import ImgRupam from '../Img/editorial-board-rupam.png';
import ImgNameerah from '../Img/editorial-board-nameerah.png';
import ImgShivani from '../Img/editorial-board-shivani.png';
import ImgAkash from '../Img/editorial-board-akash.png';
import ImgSayali from '../Img/editorial-board-sayali.png';
import ImgDas from '../Img/Impact-editiorial-board-images.png'
import ImgJumi from '../Img/Dr Jumi Borgohain.png'
import ImgArindam from '../Img/Dr Arindam R.png'

const members = {
  "editorial-chief": [
    {
      name: "Dr. Agam Vora",
      designation: "MBBS, MD-Pulmonary Medicine, Diploma-Tuberculosis and Chest Diseases, Fellow of College of Chest Physicians (FCCP), Fellow Royal College of Physicians London (FRCP)",
      title: "Editor In Chief",
      img: ImgAgam
    }
  ],
  "advisory-board": [
    {
      name: "Dr. Rupam Das",
      designation: "MBBS, MD from Gauhati Medical College, F.Diab from Dr Mohan's Chennai, CCR from Symbiosis Institute, Pune, FRCP(Edinburgh), Fellow Diabetes India",
      title: "Advisory Board",
      img: ImgRupam
    },
    {
      name: "Dr. Madhuchanda Das",
      designation: "",
      title: "Advisory Board",
      img: ImgDas
    },
    {
      name: "Dr. Jumi Borgohain",
      education: "MBBS, Guwahati Medical College; DMRT, MD, Cancer Institute (WIA), Adyar, Chennai.",
      designation: "Director and Chief Radiation Oncologist, North East Cancer Hospital and Research Institute, Jorabat, Guwahati-23, Assam.",
      title: "Advisory Board",
      img: ImgJumi
    }
  ],
  "managing-editors": [
    {
      name: "Ms. Nameerah Rakhe",
      designation: "Pharmacologist",
      title: "Managing Editors",
      img: ImgNameerah
    },
    {
      name: "Ms. Sayali Jadhav",
      designation: "QA Analyst",
      title: "Managing Editors",
      img: ImgSayali
    },
    // {
    //   name: "Ms. Shivani Choudhary",
    //   designation: "Pharmacologist",
    //   title: "Managing Editors",
    //   img: ImgShivani
    // },
    // {
    //   name: "Dr Arindam R",
    //   designation: "MBBS",
    //   title: "Managing Editors",
    //   img: ImgArindam
    // }
  ],
  // "technical-editors": [
  //   {
  //     name: "Mr. Akash Gupta",
  //     designation: "Pharmacologist",
  //     title: "Technical Editors",
  //     img: ImgAkash
  //   }
  // ]
};

const renderMemberCards = (title, members) => (
  <div className="about-ed-block-impact" key={title}>
    <div className="about-ed-role-impact">{members[0]?.title || title}</div>
    <div className="about-ed-content-impact">
      {members.map((member, index) => (
        <div className="current-issue-card-impact" key={`${title}-${index}`}>
          <div className="current-issue-card-left-impact">
            <img src={member.img} alt={member.name} />
          </div>
          <div className="current-issue-card-right-impact">
            <div className="current-issue-card-article-title">
              <h3>{member.name}</h3>
            </div>
            <div className="current-issue-card-person-name">
              <p>
                {member.education && <>{member.education}<br /></>}
                {member.designation && <>{member.designation}</>}
              </p>
            </div>
          </div>
        </div>
      ))}
    </div>
  </div>
);

const AboutEditorialBoard = () => {
  return (
    <div className="about-ed-wrapper-impact">
      <h2 className="about-ed-heading-impact">Editorial Board</h2>
      <div className="editorial-board-cards">
        {Object.entries(members).map(([title, memberList]) =>
          renderMemberCards(title, memberList)
        )}
      </div>
    </div>
  );
};

export default AboutEditorialBoard;
